import GenericAction from '@/components/actions/GenericAction.tsx'
import AActionContentGenericLayout from '@/components/actions/components/AActionContentGenericLayout.jsx'
import AActionContentDescription from '@/components/actions/components/AActionContentDescription.jsx'
import { Tags } from 'lucide-react'
import { ActionSectionHeader } from '../ActionSectionHeader.tsx'

export default function ComposeProductCategoriesAction({
  action,
  isLast = false,
  isInteractive = false,
}) {
  const output = action.outputs.find(o => o.status === 'success')
  const categories = output?.content?.product_categories ?? []

  const descriptionContent = [
    <div key="description" className="mb-2 whitespace-pre-line text-sm leading-tight">
      {output.message}
    </div>,
  ]

  return (
    <GenericAction
      title={action?.args?.comment ?? 'Compose product categories'}
      action={action}
      actionIcon={Tags}
      isLast={isLast}
      isInteractive={isInteractive}
    >
      <AActionContentGenericLayout>
        <AActionContentDescription content={descriptionContent} />
        <div className="space-y-5">
          {categories.map((category, index) => (
            <div key={index} className=" space-y-2.5  whitespace-pre-line text-base-foreground">
              <ActionSectionHeader>{category.name}</ActionSectionHeader>
              <div className="">{category.description}</div>
            </div>
          ))}
        </div>
      </AActionContentGenericLayout>
    </GenericAction>
  )
}
